<template>
  <div>
    <b-modal
      id="driver-accessibility-modal"
      ref="modalRef"
      title="Find driver"
      hide-footer
      @hidden="onHidden"
    >
      <b-form-group label="Phone Number">
        <b-input-group>
          <b-input-group-prepend class="d-flex align-items-center mr-1">
            +962
          </b-input-group-prepend>
          <b-form-input
            v-model.number="phoneNo"
            type="number"
            placeholder="Enter driver phone number"
            autofocus
          />
        </b-input-group>
      </b-form-group>
      <h4
        v-if="noDriverFound"
        class="text-danger text-center"
      >
        No driver found with this phone number
      </h4>
      <div
        v-else-if="foundDriver"
        class="d-flex justify-content-between align-items-center mb-1"
      >
        <span>Driver Name: {{ foundDriver.fullName }}</span>
        <b-button
          variant="success"
          small
          @click="redirectToDetails"
        >
          Go to details
        </b-button>
      </div>
      <b-button
        block
        :disabled="!phoneNo || searching"
        variant="primary"
        @click="searchDriver"
      >
        <b-spinner
          v-if="searching"
          small
        />
        <span v-else>Search driver</span>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api'
import {
  BModal, BFormInput, BFormGroup, BButton, BSpinner, BInputGroupPrepend, BInputGroup,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driversStore from '@/views/driver/driverStoreModule'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BModal, BFormInput, BFormGroup, BButton, BSpinner, BInputGroupPrepend, BInputGroup,
  },
  setup(_, ctx) {
    useRegisterStoreModule('drivers', driversStore)
    const phoneNo = ref('')
    const searching = ref(false)
    const noDriverFound = ref(false)
    const foundDriver = ref(null)
    const searchDriver = async () => {
      try {
        foundDriver.value = null
        noDriverFound.value = false
        searching.value = true
        const result = await ctx.root.$store.dispatch('drivers/fetchDrivers', { phoneNumber: `+962${phoneNo.value}` })
        noDriverFound.value = !result.drivers.length
        // eslint-disable-next-line prefer-destructuring
        foundDriver.value = result.drivers[0]
      } catch (err) {
        errorNotification('Try again')
      } finally {
        searching.value = false
      }
    }

    const inst = getCurrentInstance()
    const redirectToDetails = () => {
      inst.refs.modalRef.hide()
      ctx.root.$router.push({
        name: 'drivers-view',
        params: { id: foundDriver.value.id },
        query: { externalId: foundDriver.value.externalId },
      })
    }

    const onHidden = () => {
      phoneNo.value = ''
      noDriverFound.value = false
      foundDriver.value = null
    }

    return {
      redirectToDetails,
      foundDriver,
      onHidden,
      noDriverFound,
      searchDriver,
      searching,
      phoneNo,
    }
  },
}
</script>

  <style>

  </style>
